export const firebaseConfig = {
  databaseURL: "https://pascguide.firebaseio.com",
  apiKey: "AIzaSyCcx1213a-ye6LFe1jqwl3a44JgmPnG0gA",
  authDomain: "pascguide.firebaseapp.com",
  projectId: "pascguide",
  storageBucket: "pascguide.appspot.com",
  messagingSenderId: "1018010735817",
  appId: "1:1018010735817:web:4833d2ba6cbff5f4f9a918",
  measurementId: "G-4SVKBEVMHP",
};
